var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditAdminIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99203 2.74623L2.39597 10.3641C1.93994 10.8215 1.64481 11.4145 1.55501 12.0541L1.11174 15.2111C1.05641 15.6052 1.39537 15.9418 1.78903 15.8837L4.97695 15.4133C5.61171 15.3197 6.19929 15.0236 6.65234 14.5693L14.2168 6.98312M9.99203 2.74623L11.4641 1.26992C12.1629 0.569152 13.2979 0.569155 13.9967 1.26992L15.6961 2.97427C16.392 3.67219 16.392 4.80163 15.6961 5.49955L14.2168 6.98312M9.99203 2.74623L14.2168 6.98312",
    stroke: "#FF0990",
    strokeWidth: 1.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditAdminIcon);
export default __webpack_public_path__ + "static/media/edit-admin-icon.465ab92593f6138a36242fb1f41a2c47.svg";
export { ForwardRef as ReactComponent };